






















































































































import {
  IEmployeeFormFieldSubmissionData,
  IEmployeeFormFieldOptionSubmissionData,
  IEmployeeFormSubmission,
  IFormTemplate,
  FormFieldTypeEnum,
  IFormSectionData,
  IFormSectionFieldData,
  IFormTemplateData,
  IFormFieldData
} from '@/models';

import { isArray } from 'lodash';
import Vue, { PropType } from 'vue';

import { downloadDataUrl, isValidDataUrl } from '@/utils/helpers';
export default Vue.extend({
  props: {
    submission: {
      type: Object as PropType<IEmployeeFormSubmission>
    },
    template: Object as PropType<IFormTemplate>
  },

  data() {
    return {
      FormFieldTypeEnum
    };
  },

  methods: {
    isArray,
    isValidDataUrl,
    downloadDataUrl,

    genLabel(section_field: IFormSectionFieldData) {
      let label = (section_field.field_template as IFormFieldData).label;
      if (section_field.required) {
        label = `${label}*`;
      }
      return label;
    },

    genFieldDisplay(section: IFormSectionData) {
      const fieldDisplayList = [
        [] as IFormSectionFieldData[],
        [] as IFormSectionFieldData[]
      ];

      const firstColumnRange = Math.round(section.section_fields!.length / 2);

      fieldDisplayList[0] = section.section_fields!.slice(0, firstColumnRange);
      fieldDisplayList[1] = section.section_fields!.slice(
        fieldDisplayList[0].length
      );

      return fieldDisplayList;
    },

    getEmployeeFormSubmissionValueByTemplateField(
      section_field: IFormSectionFieldData
    ): string[] | string | undefined {
      const formFieldSubmission = (this.submission
        .answers as IEmployeeFormFieldSubmissionData[]).find(
        form => (form.field as IFormSectionFieldData).id === section_field.id
      );

      if (!formFieldSubmission) {
        return;
      }

      let submissons = formFieldSubmission.value
        ? [formFieldSubmission.value]
        : ['-'];

      //   if the form answer was an option submission
      if (formFieldSubmission.option_submissions.length > 0) {
        submissons = this.getEmployeeFormOptionSubmissionValueByTemplateField(
          formFieldSubmission
        );
      }

      return submissons.length > 1 ? submissons : submissons[0];
    },

    //finds the template field options related to the form option_submission
    //then extract its value
    getEmployeeFormOptionSubmissionValueByTemplateField(
      formFieldSubmission: IEmployeeFormFieldSubmissionData
    ): string[] {
      const templateField: string[] = [];

      (formFieldSubmission.option_submissions as IEmployeeFormFieldOptionSubmissionData[]).forEach(
        (option_submission: IEmployeeFormFieldOptionSubmissionData) => {
          const submisson = ((formFieldSubmission.field as IFormSectionFieldData)
            .field_template as IFormFieldData).options?.find(
            option => option.id == option_submission.option
          );

          if (!submisson) {
            return;
          }

          const templateValue = submisson.value ? submisson.value : '-';

          templateField.push(templateValue);
        }
      );
      return templateField;
    }
  }
});
